<template>
  <div class="class-list">
    <GlobalInfoBar
      title="补充绩效发放"
      content="补充绩效为商户线下核算，与系统订单回收奖励无关联关系"
    />
    <GlobalChunk icon="search" title="筛选查询">
      <div slot="filter">
        <From />
      </div>
      <Table />
    </GlobalChunk>
  </div>
</template>

<script>
import From from "./Form";
import Table from "./Table";
export default {
  name: "class-list",
  components: {
    From,
    Table
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style>
</style>